import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getGroups, joinGroupByCode } from "../../../redux/actions/groups";
import styles from "./CSSFiles/MyClass.module.css";
import JoinGroupModal from "./JoinGroupModal";
import {withTranslation} from "react-i18next"

class MyGroup extends Component {
  state = {
    showShareModal: false,
    joinGroupCode: "",
  };
  shareModalOpener = () => {
    this.setState({ showShareModal: true });
  };
  shareModalCloser = () => {
    this.setState({ showShareModal: false });
  };
  addGroupMember = () => {
    this.setState({ showShareModal: false });
    const joinGroupCodeOnly = this.state.joinGroupCode.split("/").pop();
    this.props.joinGroupByCode({ group_code: joinGroupCodeOnly });
  };

  changeJoinGroupCode = (e) => {
    this.setState({ joinGroupCode: e.target.value });
  };
  render() {
    return (
      <div className={styles.dropdown_menu1}>
        <ul>
          <div className={styles.menu1}>
            <Link to="/groups" style={{ textDecoration: "none" }}>
              <li style={{ marginTop: 6, marginBottom: 6, color: "#555555" }}>{this.props.t("common.myGroups")}</li>
            </Link>
            <hr className={styles.Hr3} />
            {/* <li style={{marginTop:6,marginBottom:6,color:"#555555"}}>View archived group</li>
          <hr className={styles.Hr3}/> */}
            {/* <Link to="/video" style={{ textDecoration: "none" }}> */}
            <li onClick={this.shareModalOpener} style={{ marginTop: 6, marginBottom: 6, color: "#555555"}} className={styles.menuList}>
            {this.props.t("common.joinGroup")}
            </li>
            {/* </Link> */}
            <JoinGroupModal
              show={this.state.showShareModal}
              shareModalCloser={this.shareModalCloser}
              addGroupMember={this.addGroupMember}
              changeJoinGroupCode={this.changeJoinGroupCode}
            />
          </div>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // memberSuggestions:state.users
    user: state.profile.user,
    //memberSuggestions:[{name:'Anmol',id:1},{id:2,name:'Himani'},{id:3,name:'Shivam'},{id:4,name:'Harsh'},{id:5,name:'Anshika'},{id:6,name:'Medha'}],
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    joinGroupByCode: (data) => dispatch(joinGroupByCode(data)),
    getGroups: () => dispatch(getGroups()),
  };
};
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(MyGroup));
